import toMutable from './toMutable'

export default function mutable(data) {
  return toMutable(data)
}
